import { render } from "./CastComponent.vue?vue&type=template&id=145a3716&scoped=true"
import script from "./CastComponent.vue?vue&type=script&lang=js"
export * from "./CastComponent.vue?vue&type=script&lang=js"

import "./CastComponent.vue?vue&type=style&index=0&id=145a3716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145a3716"]])

export default __exports__